<template>
  <div class="xy">
    <div class="question">{{ $t('promotion_new.xy.configure_xy') }}</div>
    <div class="xy_parameters">
      <div class="xy_parameter input-group">
        <span>{{ $t('promotion_new.xy.text1') }}</span>
        <input min="1" type="number" v-model="promotion.triggerParameters.x">
        <div class="input-overlay">{{ $t('promotion_new.products') }}</div>
      </div>
      <div class="xy_parameter input-group">
        <span>{{ $t('promotion_new.xy.text2') }}</span>
        <input min="1" type="number" v-model="promotion.triggerParameters.y">
        <div class="input-overlay">{{ $t('promotion_new.free_products') }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "XYParameter",

  props: {
    promotion: Object
  }
}
</script>

<style lang="scss" scoped>
.xy_parameters {
  align-self: flex-start;

  input {
    max-width: 160px;
  }
}

.xy_parameter {
  display: flex;
  position: relative;
  font-weight: bold;
  align-items: center;
  justify-content: flex-end;
  text-align: right;
  margin-bottom: 8px;

  &.input-group {
    flex-direction: row !important;
  }
}
</style>